import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
//import { exist } from '../../handlers/utils';
import { 
	Table,
	Card 
} from 'reactstrap';
import { 
	Container, 
	Col, 
	Row 
} from 'reactstrap';
import { 
	fillDashboardStatistics,
	fillDashboardMonthStatistics, 
	fillDashboardDayStatistics, 
	newStadistic,
	drawMonthStatistics,
	drawMonthStatisticsID
} from '../../store/actions/orderActions';
import { 
	number_format,
	zerofilled
} from '../../store/actions/UtilsOperation';
import { ADMIN_OWNER } from '../../constants/bitwiseOperations';

class Dashboard extends Component {
  	constructor(props) {
		super(props);
		this.props.fillDashboardStatistics()
			this.props.fillDashboardMonthStatistics().then( (res) => {
				if(this.props.months.length > 0){
					this.props.drawMonthStatisticsID(this.props.months[0].id);
				}	
			}).catch((err) => {  
				console.log(err,"fillDashboardMonthStatistics store fail")
			});
	    //this.props.fillDashboardDayStatistics(moment().format("MM"),moment().format("YYYY"))
		//this.props.drawMonthStatistics(moment().format("MM"))
  	}

  	componentDidUpdate(prevProps, prevState) {
	    if(prevProps.branch !== this.props.branch){
			this.props.fillDashboardStatistics()
		    this.props.fillDashboardMonthStatistics().then( (res) => {
				this.props.drawMonthStatisticsID(this.props.months[0].id);
			}).catch((err) => {  
				console.log(err,"fillDashboardStatistics store fail")
			});
	    }
	}

	handleOrderRedirection(type){
		switch(type) {
			case 'in_progress':
				localStorage.setItem(
					"selectedStatusOrders",
					JSON.stringify([{name: 'En curso', value: type}])
				);
				break;
			case 'completed':
				localStorage.setItem(
					"selectedStatusOrders",
					JSON.stringify([{name: 'Completada', value: type}])
				);
				break;
			case 'cancelled':
				localStorage.setItem(
					"selectedStatusOrders",
					JSON.stringify([{name: 'Cancelada', value: type}])
				);
				break;
		}
	}

  	render() {
		// Órdenes 
		var propsStats = this.props.stats
		var	ordersStats = propsStats && propsStats.orders ? propsStats.orders : {}

		var	currentStats = ordersStats && ordersStats.current ? ordersStats.current : {}
		var	currentPaymentsStats = currentStats && currentStats.payments ? currentStats.payments : {}

		var	onGoingStats = ordersStats && ordersStats.ongoing ? ordersStats.ongoing : {}
		var	onGoingPaymentsStats = onGoingStats && onGoingStats.payments ? onGoingStats.payments : {}

		var	unattendedStats = ordersStats && ordersStats.unattended ? ordersStats.unattended : {}
		var montData = this.props.monthData && this.props.monthData.orders && this.props.monthData.orders.current ? this.props.monthData.orders.current:[];
		var orderStats= {
			current:{
				created: currentStats.created ? currentStats.created : 0,
				hanging: currentStats.hanging ? currentStats.hanging : 0,
				attended: currentStats.attended ? currentStats.attended : 0,
				attended_asap: currentStats.attended_asap ? currentStats.attended_asap : 0,
				attended_completed: currentStats.attended_completed ? currentStats.attended_completed : 0,
				attended_cancelled: currentStats.attended_cancelled ? currentStats.attended_cancelled : 0,
				attended_scheduled: currentStats.attended_scheduled ? currentStats.attended_scheduled : 0 ,
				payments:{
					received_count: currentPaymentsStats.received_count ? currentPaymentsStats.received_count : 0,
					received_refunded_count: currentPaymentsStats.received_refunded_count ? currentPaymentsStats.received_refunded_count : 0,
					received_reconciled_count: currentPaymentsStats.received_reconciled_count ? currentPaymentsStats.received_reconciled_count : 0,
					received_uncompleted_count: currentPaymentsStats.received_uncompleted_count ? currentPaymentsStats.received_uncompleted_count : 0,
					pending_count: currentPaymentsStats.pending_count ? currentPaymentsStats.pending_count : 0,
					cancelled_count: currentPaymentsStats.cancelled_count ? currentPaymentsStats.cancelled_count : 0,
					total_e2: currentPaymentsStats.total_e2 ? number_format(parseFloat(currentPaymentsStats.total_e2)/100) : 0,
					expected_total_e2: currentPaymentsStats.expected_total_e2 ? number_format(parseFloat(currentPaymentsStats.expected_total_e2)/100) : 2,
					registered_total_e2: currentPaymentsStats.registered_total_e2 ? number_format(parseFloat(currentPaymentsStats.registered_total_e2)/100) : 0,
					reconciled_total_e2: currentPaymentsStats.reconciled_total_e2 ? number_format(parseFloat(currentPaymentsStats.reconciled_total_e2)/100) : 0,
					uncompleted_total_e2: currentPaymentsStats.uncompleted_total_e2 ? number_format(parseFloat(currentPaymentsStats.uncompleted_total_e2)/100) : 0,
					refunded_total_e2: currentPaymentsStats.refunded_total_e2 ? number_format(parseFloat(currentPaymentsStats.refunded_total_e2)/100) : 0,
					pending_total_e2: currentPaymentsStats.pending_total_e2 ? number_format(parseFloat(currentPaymentsStats.pending_total_e2)/100) : 0,
					cancelled_total_e2: currentPaymentsStats.cancelled_total_e2 ? number_format(parseFloat(currentPaymentsStats.cancelled_total_e2)/100) : 0,
					total_e2_without_canceled: (currentPaymentsStats.total_e2 || onGoingPaymentsStats.total_e2  === 0) && (currentPaymentsStats.cancelled_total_e2 || onGoingPaymentsStats.cancelled_total_e2  === 0) ? number_format( ( parseFloat(currentPaymentsStats.total_e2) - parseFloat(currentPaymentsStats.cancelled_total_e2) ) /100 ) : 0,
				},
				payment_pending: currentStats.payment_pending ? currentStats.payment_pending : 0,
				payment_reported: currentStats.payment_reported ? currentStats.payment_reported : 0,
				payment_approved: currentStats.payment_approved ? currentStats.payment_approved : 0,
				total: currentStats.total ? currentStats.total : 0,
				total_asap: currentStats.total_asap ? currentStats.total_asap : 0,
				total_scheduled: currentStats.total_scheduled ? currentStats.total_scheduled : 0,
				unattended: currentStats.unattended ? currentStats.unattended : 0,
				unattended_asap: currentStats.unattended_asap ? currentStats.unattended_asap : 0,
				unattended_scheduled: currentStats.unattended_scheduled ? currentStats.unattended_scheduled : 0,
			},
			ongoing:{
				created: onGoingStats.created ? onGoingStats.created : 0,
				hanging: onGoingStats.hanging ? onGoingStats.hanging : 0,
				attended: onGoingStats.attended ? onGoingStats.attended : 0,
				attended_asap: onGoingStats.attended_asap ? onGoingStats.attended_asap : 0,
				attended_completed: onGoingStats.attended_completed ? onGoingStats.attended_completed : 0,
				attended_cancelled: onGoingStats.attended_cancelled ? onGoingStats.attended_cancelled : 0,
				attended_scheduled: onGoingStats.attended_scheduled ? onGoingStats.attended_scheduled : 0 ,
				payments:{
					received_count: onGoingPaymentsStats.received_count ? onGoingPaymentsStats.received_count : 0,
					received_refunded_count: onGoingPaymentsStats.received_refunded_count ? onGoingPaymentsStats.received_refunded_count : 0,
					received_reconciled_count: onGoingPaymentsStats.received_reconciled_count ? onGoingPaymentsStats.received_reconciled_count : 0,
					received_uncompleted_count: onGoingPaymentsStats.received_uncompleted_count ? onGoingPaymentsStats.received_uncompleted_count : 0,
					pending_count: onGoingPaymentsStats.pending_count ? onGoingPaymentsStats.pending_count : 0,
					cancelled_count: onGoingPaymentsStats.cancelled_count ? onGoingPaymentsStats.cancelled_count : 0,
					total_e2: onGoingPaymentsStats.total_e2 ? number_format(parseFloat(onGoingPaymentsStats.total_e2)/100) : 0,
					expected_total_e2: onGoingPaymentsStats.expected_total_e2 ? number_format(parseFloat(onGoingPaymentsStats.expected_total_e2)/100) : 0,
					registered_total_e2: onGoingPaymentsStats.registered_total_e2 ? number_format(parseFloat(onGoingPaymentsStats.registered_total_e2)/100) : 0,
					reconciled_total_e2: onGoingPaymentsStats.reconciled_total_e2 ? number_format(parseFloat(onGoingPaymentsStats.reconciled_total_e2)/100) : 0,
					uncompleted_total_e2: onGoingPaymentsStats.uncompleted_total_e2 ? number_format(parseFloat(onGoingPaymentsStats.uncompleted_total_e2)/100) : 0,
					refunded_total_e2: onGoingPaymentsStats.refunded_total_e2 ? number_format(parseFloat(onGoingPaymentsStats.refunded_total_e2)/100) : 0,
					pending_total_e2: onGoingPaymentsStats.pending_total_e2 ? number_format(parseFloat(onGoingPaymentsStats.pending_total_e2)/100) : 0,
					cancelled_total_e2: onGoingPaymentsStats.cancelled_total_e2 ? number_format(parseFloat(onGoingPaymentsStats.cancelled_total_e2)/100) : 0,
					total_e2_without_canceled: (onGoingPaymentsStats.total_e2 || onGoingPaymentsStats.total_e2  === 0) && (onGoingPaymentsStats.cancelled_total_e2 || onGoingPaymentsStats.cancelled_total_e2  === 0) ? number_format( ( parseFloat(onGoingPaymentsStats.total_e2) - parseFloat(onGoingPaymentsStats.cancelled_total_e2) ) /100 )  : 0,
				},
				payment_pending: onGoingStats.payment_pending ? onGoingStats.payment_pending : 0,
				payment_reported: onGoingStats.payment_reported ? onGoingStats.payment_reported : 0,
				payment_approved: onGoingStats.payment_approved ? onGoingStats.payment_approved : 0,
				total: onGoingStats.total ? onGoingStats.total : 0,
				total_asap: onGoingStats.total_asap ? onGoingStats.total_asap : 0,
				total_scheduled: onGoingStats.total_scheduled ? onGoingStats.total_scheduled : 0,
				unattended: onGoingStats.unattended ? onGoingStats.unattended : 0,
				unattended_asap: onGoingStats.unattended_asap ? onGoingStats.unattended_asap : 0,
				unattended_scheduled: onGoingStats.unattended_scheduled ? onGoingStats.unattended_scheduled : 0,
			},
			unattended:{
				confirmed: unattendedStats.confirmed ? onGoingStats.confirmed : 0,
				confirmed_asap: unattendedStats.confirmed_asap ? onGoingStats.confirmed_asap : 0,
				confirmed_scheduled: unattendedStats.confirmed_scheduled ? onGoingStats.confirmed_scheduled : 0,
				not_running: unattendedStats.not_running ? onGoingStats.not_running : 0,
				payments:{},
				running: unattendedStats.running ? onGoingStats.running : 0,
				total: unattendedStats.total ? onGoingStats.total : 0,
				unconfirmed: unattendedStats.unconfirmed ? onGoingStats.unconfirmed : 0,
			},
			months:{
				created: montData && montData.created ? montData.created : 0,
				hanging: montData.hanging ? montData.hanging : 0,
				attended: montData && montData.attended ? montData.attended : 0,
				attended_asap: montData && montData.attended_asap ? montData.attended_asap : 0,
				attended_completed: montData && montData.attended_completed ? montData.attended_completed : 0,
				attended_cancelled: montData && montData.attended_cancelled ? montData.attended_cancelled : 0,
				attended_scheduled: montData && montData.attended_scheduled ? montData.attended_scheduled : 0 ,
				payments:{
					received_count: montData && montData.payments && montData.payments.received_count ? montData.payments.received_count : 0,
					received_refunded_count: montData && montData.payments && montData.payments.received_refunded_count ? montData.payments.received_refunded_count : 0,
					received_reconciled_count: montData && montData.payments && montData.payments.received_reconciled_count ? montData.payments.received_reconciled_count : 0,
					received_uncompleted_count: montData && montData.payments && montData.payments.received_uncompleted_count ? montData.payments.received_uncompleted_count : 0,
					pending_count: montData && montData.payments && montData.payments.pending_count ? montData.payments.pending_count : 0,
					cancelled_count: montData && montData.payments && montData.payments.cancelled_count ? montData.payments.cancelled_count : 0,
					total_e2: montData && montData.payments && montData.payments.total_e2 ? number_format(parseFloat(montData.payments.total_e2)/100) : 0,
					expected_total_e2: montData && montData.payments && montData.payments.expected_total_e2 ? number_format(parseFloat(montData.payments.expected_total_e2)/100) : 0,
					registered_total_e2: montData && montData.payments && montData.payments.registered_total_e2 ? number_format(parseFloat(montData.payments.registered_total_e2)/100) : 0,
					reconciled_total_e2: montData && montData.payments && montData.payments.reconciled_total_e2 ? number_format(parseFloat(montData.payments.reconciled_total_e2)/100) : 0,
					uncompleted_total_e2: montData && montData.payments && montData.payments.uncompleted_total_e2 ? number_format(parseFloat(montData.payments.uncompleted_total_e2)/100) : 0,
					refunded_total_e2: montData && montData.payments && montData.payments.refunded_total_e2 ? number_format(parseFloat(montData.payments.refunded_total_e2)/100) : 0,
					pending_total_e2: montData && montData.payments && montData.payments.pending_total_e2 ? number_format(parseFloat(montData.payments.pending_total_e2)/100) : 0,
					cancelled_total_e2: montData && montData.payments && montData.payments.cancelled_total_e2 ? number_format(parseFloat(montData.payments.cancelled_total_e2)/100) : 0,
					total_e2_without_canceled:montData && montData.payments && ( (montData.payments.total_e2 || montData.payments.total_e2 === 0) && (montData.payments.cancelled_total_e2 || montData.payments.cancelled_total_e2 === 0 ) )  ? number_format(parseFloat(montData.payments.total_e2 - montData.payments.cancelled_total_e2)/100) : 0,
				},
				payment_pending: montData && montData.payment_pending ? montData.payment_pending : 0,
				payment_reported: montData && montData.payment_reported ? montData.payment_reported : 0,
				payment_approved: montData && montData.payment_approved ? montData.payment_approved : 0,
				total: montData && montData.total ? montData.total : 0,
				total_asap: montData && montData.total_asap ? montData.total_asap : 0,
				total_scheduled: montData && montData.total_scheduled ? montData.total_scheduled : 0,
				unattended: montData && montData.unattended ? montData.unattended : 0,
				unattended_asap: montData && montData.unattended_asap ? montData.unattended_asap : 0,
				unattended_scheduled: montData && montData.unattended_scheduled ? montData.unattended_scheduled : 0,
			}
		}

		//var onGoingStatsPast = this.props.orderPast && this.props.orderPast.orders && this.props.orderPast.orders.ongoing ? this.props.orderPast.orders.ongoing : {}
		//var onGoingPaymentsStatsPast = this.props.orderPast && this.props.orderPast.orders && this.props.orderPast.orders.ongoing && this.props.orderPast.orders.ongoing.payments ? this.props.orderPast.orders.ongoing.payments :{}
		/*var orderPastStats= {
			ongoing:{
				created: onGoingStatsPast.created ? onGoingStatsPast.created : 0,
				attended: onGoingStatsPast.attended ? onGoingStatsPast.attended : 0,
				attended_asap: onGoingStatsPast.attended_asap ? onGoingStatsPast.attended_asap : 0,
				attended_completed: onGoingStatsPast.attended_completed ? onGoingStatsPast.attended_completed : 0,
				attended_cancelled: onGoingStatsPast.attended_cancelled ? onGoingStatsPast.attended_cancelled : 0,
				attended_scheduled: onGoingStatsPast.attended_scheduled ? onGoingStatsPast.attended_scheduled : 0 ,
				payments:{
					received_count: onGoingPaymentsStatsPast.received_count ? onGoingPaymentsStatsPast.received_count : 0,
					received_refunded_count: onGoingPaymentsStatsPast.received_refunded_count ? onGoingPaymentsStatsPast.received_refunded_count : 0,
					received_reconciled_count: onGoingPaymentsStatsPast.received_reconciled_count ? onGoingPaymentsStatsPast.received_reconciled_count : 0,
					received_uncompleted_count: onGoingPaymentsStatsPast.received_uncompleted_count ? onGoingPaymentsStatsPast.received_uncompleted_count : 0,
					pending_count: onGoingPaymentsStatsPast.pending_count ? onGoingPaymentsStatsPast.pending_count : 0,
					cancelled_count: onGoingPaymentsStatsPast.cancelled_count ? onGoingPaymentsStatsPast.cancelled_count : 0,
					total_e2: onGoingPaymentsStatsPast.total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.total_e2)/100) : 0,
					expected_total_e2: onGoingPaymentsStatsPast.expected_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.expected_total_e2)/100) : 0,
					registered_total_e2: onGoingPaymentsStatsPast.registered_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.registered_total_e2)/100) : 0,
					reconciled_total_e2: onGoingPaymentsStatsPast.reconciled_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.reconciled_total_e2)/100) : 0,
					uncompleted_total_e2: onGoingPaymentsStatsPast.uncompleted_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.uncompleted_total_e2)/100) : 0,
					refunded_total_e2: onGoingPaymentsStatsPast.refunded_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.refunded_total_e2)/100) : 0,
					pending_total_e2: onGoingPaymentsStatsPast.pending_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.pending_total_e2)/100) : 0,
					cancelled_total_e2: onGoingPaymentsStatsPast.cancelled_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.cancelled_total_e2)/100) : 0,
					total_e2_without_canceled:(onGoingPaymentsStatsPast.total_e2 || onGoingPaymentsStatsPast.total_e2  === 0) && (onGoingPaymentsStatsPast.cancelled_total_e2 || onGoingPaymentsStatsPast.cancelled_total_e2  === 0) ? number_format( ( parseFloat(onGoingPaymentsStatsPast.total_e2) - parseFloat(onGoingPaymentsStatsPast.cancelled_total_e2) ) /100 ) : 0,
				},
				payment_pending: onGoingStatsPast.payment_pending ? onGoingStatsPast.payment_pending : 0,
				payment_reported: onGoingStatsPast.payment_reported ? onGoingStatsPast.payment_reported : 0,
				payment_approved: onGoingStatsPast.payment_approved ? onGoingStatsPast.payment_approved : 0,
				total: onGoingStatsPast.total ? onGoingStatsPast.total : 0,
				total_asap: onGoingStatsPast.total_asap ? onGoingStatsPast.total_asap : 0,
				total_scheduled: onGoingStatsPast.total_scheduled ? onGoingStatsPast.total_scheduled : 0,
				unattended: onGoingStatsPast.unattended ? onGoingStatsPast.unattended : 0,
				unattended_asap: onGoingStatsPast.unattended_asap ? onGoingStatsPast.unattended_asap : 0,
				unattended_scheduled: onGoingStatsPast.unattended_scheduled ? onGoingStatsPast.unattended_scheduled : 0,
			}
		}*/

		var listStats =  orderStats // : orderPastStats
		//console.log("listStats.current",listStats.months)
		return <Container className="mt-4" fluid>
			<div className="animated fadeIn">
				<div className={ 'mb-2'}>
					<h3 className="my-4 font-weight-bold" style={{color:"#888"}}>
						{this.props.json_lang.dashboard.today}
					</h3>

					<Row>
						{/* <Col sm="6" md="3">
							<div className="text-white bg-primary card">
								<div className="card-body">
									<div className="h1 text-muted text-right mb-2" style={{ position: "absolute", right: "25px"}}>
										<i className="icon-user-follow"></i>
									</div>
									<div className="h1 mb-0 mt-3" style={{fontWeight: "bolder"}}>385</div>
									<small className="text-muted text-uppercase font-weight-bold">Cantidad de usuarioss</small>
								</div>
							</div>
						</Col> */}
						<Col sm="6" md="6">
							<Link to={'order-management'} onClick={() => this.handleOrderRedirection('in_progress')}>
								<div className={ `text-white card bg-${ this.props.isZupper ? `zupper` : `good`}`}>
									<div className="card-body">
										<div className="h1 text-muted text-right mb-2" style={{ position: "absolute", right: "25px"}}>
											<i className="icon-basket-loaded"></i>
										</div>
										<div className="h1 mb-0 mt-3" style={{fontWeight: "bolder"}}>{zerofilled(listStats.ongoing.unattended)}</div>
										<small className="text-uppercase font-weight-bold">Órdenes Pendientes</small>
									</div>
								</div>
							</Link>
						</Col>
						<Col sm="6" md="6">
							<Link to={'order-management'} onClick={() => this.handleOrderRedirection('cancelled')}>
								<div className={ `text-white card bg-${ this.props.isZupper ? `zupper` : `wrong`}`}>
									<div className="card-body">
										<div className="h1 text-muted text-right mb-2" style={{ position: "absolute", right: "25px"}}>
											<i className="icon-basket"></i>
										</div>
										<div className="h1 mb-0 mt-3" style={{fontWeight: "bolder"}}>{listStats.ongoing.attended_cancelled}</div>
										<small className="text-uppercase font-weight-bold">Órdenes Canceladas</small>
									</div>
								</div>
							</Link>
						</Col>
						{
							this.props.accountType >= ADMIN_OWNER ?
							<React.Fragment>
								<Col sm="6" md="6">
									<Link to={'/company-charges'}>
										<div className={ `text-white card bg-${ this.props.isZupper ? `zupper` :`money`}`}>
											<div className="card-body">
												<div className="h1 text-muted text-right mb-2" style={{ position: "absolute", right: "25px"}}>
													<i className="fa fa-money"></i>
												</div>
												<div className="h1 mb-0 mt-3" style={{fontWeight: "bolder"}}>{this.props.currency + ' ' + listStats.ongoing.payments.reconciled_total_e2}</div>
												<small className="text-uppercase font-weight-bold">Vol. de Ventas</small>
											</div>
										</div>
									</Link>
								</Col>
								<Col sm="6" md="6">
									<Link to={'/order-management'} onClick={() => this.handleOrderRedirection('completed')}>
										<div className={ `text-white card bg-${ this.props.isZupper ? `zupper` : `money`}`}>
											<div className="card-body">
												<div className="h1 text-muted text-right mb-2" style={{ position: "absolute", right: "25px"}}>
													<i className="icon-basket-loaded"></i>
												</div>
												<div className="h1 mb-0 mt-3" style={{fontWeight: "bolder"}}>{zerofilled(listStats.current.attended_completed)}</div>
												<small className="text-uppercase font-weight-bold">Órdenes Completadas</small>
											</div>
										</div>
									</Link>
								</Col>
							</React.Fragment>
							:
							<Col sm="12" md="12">
								<Link to={'/order-management'} onClick={() => this.handleOrderRedirection('completed')}>
									<div className={ `text-white card bg-${ this.props.isZupper ? `zupper` : `money`}`}>
										<div className="card-body">
											<div className="h1 text-muted text-right mb-2" style={{ position: "absolute", right: "25px"}}>
												<i className="icon-basket-loaded"></i>
											</div>
											<div className="h1 mb-0 mt-3" style={{fontWeight: "bolder"}}>{zerofilled(listStats.current.attended_completed)}</div>
											<small className="text-uppercase font-weight-bold">Órdenes Completadas</small>
										</div>
									</div>
								</Link>
							</Col>
						}
					</Row>
					<Row>
						<Col sm="6" md="6">
							<div className="d-flex flex-column my-4 font-weight-bold">
								<h3 className="font-weight-bold" style={{color:"#888"}}>{this.props.json_lang.dashboard.today}</h3>
								<span style={{textTransform: "capitalize"}}>{moment().format("dddd D, MMMM")}</span>
							</div>
							<Card>
								<Table className="dashboard-tables" bordered>
									<tbody>
										{
											this.props.accountType >= ADMIN_OWNER ?
												<tr>
													<th scope="row">{ this.props.currency + " " + listStats.ongoing.payments.reconciled_total_e2}</th>
													<td>Ventas</td>
												</tr>
											:
											null
										}
										{/*<tr>
											<th scope="row">{zerofilled(listStats.ongoing.created)}</th>
											<td>Órdenes Pendientes</td>
										</tr>*/}
										<tr>
											<th scope="row">{zerofilled(listStats.ongoing.created)}</th>
											<td>Órdenes creadas</td>
										</tr>
										<tr>
											<th scope="row">{zerofilled(listStats.ongoing.attended_completed)}</th>
											<td>Órdenes Completadas</td>
										</tr>
										<tr>
											<th scope="row">{zerofilled(listStats.ongoing.attended_cancelled)}</th>
											<td>Órdenes Canceladas</td>
										</tr>
									</tbody>
								</Table>
							</Card>
						</Col>
						<Col sm="6" md="6">
							<div className="d-flex flex-column my-4 font-weight-bold">
								<h3 className="font-weight-bold" style={{color:"#888"}}>{this.props.json_lang.dashboard.month}</h3>
								<span style={{textTransform: "capitalize"}}>{moment().format("MMMM YYYY")}</span>
							</div>
							<Card>
								<Table className="dashboard-tables" bordered>
									<tbody>
										{
											this.props.accountType >= ADMIN_OWNER ?
												<tr>
													<th scope="row">{this.props.currency + " " + listStats.months.payments.reconciled_total_e2}</th>
													<td>Ventas</td>
												</tr>
											:
											null
										}
										<tr>
											<th scope="row">{zerofilled(listStats.months.unattended + listStats.ongoing.created)}</th>
											<td>Órdenes Pendientes</td>
										</tr>
										<tr>
											<th scope="row">{zerofilled(listStats.months.attended_completed + listStats.ongoing.attended_completed)}</th>
											<td>Órdenes Completadas</td>
										</tr>
										<tr>
											<th scope="row">{zerofilled(listStats.months.attended_cancelled + listStats.ongoing.attended_cancelled)}</th>
											<td>Órdenes Canceladas</td>
										</tr>
									</tbody>
								</Table>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		</Container>
  	}
}

const mapStateToProps = (state) => {
	let zupper = false;
	if(state.company){
		if(state.company.id === 7  || state.company.id === 120){
			zupper = true
		}	
	}
	
	return {
		admin_type:state.session && state.session.admin_type && state.session.admin_type.id ? state.session.admin_type.id : "",
		json_lang: state.json_lang,
		stats: state.dashboardStatistics,
		currency: state.currencies.local.symbol,
		orders: state.orders,
		orderPast: state.orderPast,
		days:state.dashboardDaysStatistics,
		months:state.dashboardMonthsStatistics,
		monthData:state.dashboardMonthsData,
		branch:state.branch,
		accountType: state.session.account.type,
		isZupper:zupper
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fillDashboardStatistics: () => dispatch(fillDashboardStatistics()),
		fillDashboardDayStatistics: (month,year) => dispatch(fillDashboardDayStatistics(month,year)),
		fillDashboardMonthStatistics: (year) => dispatch(fillDashboardMonthStatistics(year)),
		newStadistic: (date) => dispatch(newStadistic(date)),
		drawMonthStatistics:(month) => dispatch(drawMonthStatistics(month)),
		drawMonthStatisticsID:(id) => dispatch(drawMonthStatisticsID(id))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js